var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEshopShoppingBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M23.022 6.598H17.54V4.356c0-1.578-.372-2.747-1.105-3.477C15.542 0 14.367 0 13.798 0h-2.584c-1.3 0-2.325.397-3.048 1.178C7.026 2.403 7.068 4.14 7.08 4.397v2.201H1.403L0 23.863h24.615L23.022 6.598ZM9.176 2.104c.456-.489 1.142-.736 2.038-.736h2.591c.467 0 1.175 0 1.663.48.49.48.703 1.308.703 2.508v2.242H8.448V4.33c-.002-.014-.072-1.371.725-2.226h.003ZM2.665 7.966H7.08v3.419h1.368v-3.42h7.723v3.42h1.367v-3.42h4.238l1.34 14.53H1.484l1.181-14.53Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEshopShoppingBag);
export default __webpack_public_path__ + "static/media/eshop-shopping-bag.57dcc981ee52ffb7b1f2d7af4edeff6a.svg";
export { ForwardRef as ReactComponent };